/**
 * 429 限流熔断器
 * - 被后端限流后进入 75s 冷却：期间请求在本地短路，不再发网络请求（避免窗口被不断续命）
 * - 冷却必须长于后端 60s 限流窗口，探活请求才会落在旧窗口之外，实现自愈
 * - 限流 toast 10s 内只弹一次，轮询场景不再刷屏
 */

const COOL_DOWN_MS = 75_000
const TOAST_GAP_MS = 10_000

let coolUntil = 0
let lastToastAt = 0

export function isRateLimitCooling(): boolean {
  return Date.now() < coolUntil
}

export function markRateLimited(): void {
  coolUntil = Date.now() + COOL_DOWN_MS
}

/** 是否允许再弹一次限流提示（10s 去重） */
export function consumeRateLimitToast(): boolean {
  const now = Date.now()
  if (now - lastToastAt < TOAST_GAP_MS) return false
  lastToastAt = now
  return true
}
